import styled from 'styled-components';

import variables from '../../../styles/variables';
import searhIcon from '../../../images/search-icon.svg';

// GENERAL BLADE STYLES
export const Phase1Screen = styled.div`
  width: 100%;
  height: auto;
`;

export const BladeTitle = styled.h2`
  color: #eb0000;
  width: 100%;
  font-size: 43px;
  font-weight: 600;
  line-height: 40px;
  margin-bottom: 0;
  @media screen and (max-width: 865px) {
    font-size: 38px;
  }
  @media screen and (max-width: 768px) {
    font-size: 30px;
  }
`;

export const BladeSubtitle = styled.h3`
  color: #333333;
  font-size: 18px;
  font-weight: 600;
  line-height: 30px;
  margin-bottom: 18px;
  @media screen and (max-width: 768px) {
    font-size: 18px;
  }
`;

export const SectionWrapper = styled.div`
  margin-top: 40px;
  &#nextButton {
    margin: 0 0 30px;

    @media screen and (max-width: 768px) {
      text-align: center;
    }
  }
`;

export const SectionHeading = styled.p`
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 18px;
`;

export const ErrorMsg = styled.div`
  color: ${variables.colorRed};
  font-size: 12px;
  clear: both;
  &.recaptcha {
    margin-top: 0.5rem;
  }
  &#locationError {
    margin-bottom: 10px;
  }
  &#carrierError {
    margin-bottom: 10px;
  }
`;

// BUTTON
export const NextButton = styled.button`
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.64px;
  min-width: 250px;
  height: 53px;
  cursor: pointer;
  border: none;
  background: ${variables.colorRed};
  color: ${variables.colorWhite};
  border-radius: 26px;
  box-shadow:
    0 2px 4px 0 rgba(53, 43, 43, 0.24),
    0 2px 4px 0 rgba(238, 46, 36, 0.49);
  transition: all 0.3s;
  &:hover {
    background: ${variables.colorWhite};
    color: ${variables.colorRed};
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
  }
  @media screen and (max-width: 768px) {
    width: 60%;
  }
`;

export const UIWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
`;

// PHONE DETAILS
export const MemoryContainer = styled.div`
  margin-top: 15px;
  .memorySelector {
    margin-bottom: 0;
    border: solid 1px ${variables.colorGreyMedium};
    border-radius: 8px;
    padding: 13px;
    button:last-child {
      margin-right: 0;
    }
  }
`;

export const ColourPickerContainer = styled.div`
  margin-top: 15px;
  margin-right: 20px;
  .selectable {
    align-items: center;
    justify-items: center;
    border: solid 1px ${variables.colorGreyMedium};
    border-radius: 8px;
    padding: 2px 4px;
    button {
      margin: 14px 10px;
      width: 24px;
      height: 24px;
    }
  }
`;

export const PhoneTitle = styled.h1`
  margin-bottom: 50px;
  width: 100%;
  text-transform: none;
  font-size: 24px;
  @media screen and (max-width: 768px) {
    font-size: 20px;
  }
`;

// CARRIERS STYLES
export const CarriersList = styled.div``;

// LEGAL TEXT
export const LegalText = styled.p`
  font-size: 12px;
  line-height: 1.33;
`;

export const StoreSearch = styled.input`
  transition: all 0.5s ease-in-out;
  width: 100%;
  height: 40px;
  border-radius: 20px;
  padding-left: 60px;
  border: none;
  outline-offset: none;
  background-color: #f5f5f5;
  background-image: url(${searhIcon});
  background-repeat: no-repeat;
  background-position: 30px center;
  background-size: 15px 16px;

  &::placeholder {
    transition: all 0.75s;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    color: rgba(51, 51, 51, 0.51);
  }
`;
